var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89.108,
    height: 108.787,
    viewBox: "0 0 89.108 108.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_1644",
    x: 0,
    y: 0,
    width: 89.108,
    height: 108.787,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_1645",
    x: 6.163,
    y: 77.719,
    width: 27.657,
    height: 27.84,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1745",
    "data-name": "Group 1745",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1741",
    "data-name": "Group 1741",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#Path_1644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1644-2",
    "data-name": "Path 1644",
    d: "M50.028,30.566c-.429-.179-.867-.334-1.308-.479,0-1.679.006-3.186.012-3.627.015-1.142.041-2.273.053-3.393a24.236,24.236,0,0,0-.089-4.22,23.512,23.512,0,0,0-.949-5.464,15.893,15.893,0,0,0-1.331-3.724A19.667,19.667,0,0,0,36.6,1.328,17.592,17.592,0,0,0,31.494.1a19.75,19.75,0,0,0-7.222.6l-.118.027V.739a19.57,19.57,0,0,0-10.5,7.268C8.657,14.8,10.088,22.159,9.874,30.1A23.521,23.521,0,0,0,5.113,33C-2.6,39.751.931,50.415.142,59.458c.923,5.64,6.479,3.448,10.314,5.971a9.994,9.994,0,0,1,4.177,6.36,14.678,14.678,0,0,0,.713,4.08,5.129,5.129,0,0,0,4.4,2.686c13.628-1.549,36.426,6.139,39.143-13.531-1.234-11.311,4.553-28.829-8.862-34.459m-15.877,29.8a4.9,4.9,0,0,1-9.517-.9A75.366,75.366,0,0,1,24.67,48,5.045,5.045,0,0,1,28.4,44.26,4.944,4.944,0,0,1,34.4,48.526a66.338,66.338,0,0,1-.247,11.837M19.66,29.45V18.621A12.1,12.1,0,0,1,20.835,15a9.816,9.816,0,0,1,8.535-5.175A9.812,9.812,0,0,1,37.781,15a12.1,12.1,0,0,1,1.17,3.585c0,.031,0,.062.005.093V29.45Z",
    transform: "translate(15 15)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#Path_1645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1645-2",
    "data-name": "Path 1645",
    d: "M4.312,240.469c-5.713.976-4.609,10.2,1.46,9.72a4.862,4.862,0,0,0,.53-.08,4.921,4.921,0,0,0-1.99-9.64",
    transform: "translate(14.59 -156.65)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonLocked);
export default __webpack_public_path__ + "static/media/lesson_locked.1faf0a3b533fb752199055f19cdf7013.svg";
export { ForwardRef as ReactComponent };